import { onUnmounted, ref } from 'vue'

import type { Nullable } from '~/core/types'

export enum ScreenWidth {
  desktop = 1024,
  largeDesktop = 1500,
}

export function useMatchMedia(screenWidth: ScreenWidth) {
  const config = useRuntimeConfig()
  const queryList = import.meta.client ? matchMedia(`(min-width : ${screenWidth}px)`) : null
  const mediaQueryList = ref<Nullable<MediaQueryList>>(queryList)
  const matches = ref(mediaQueryList.value?.matches ?? !config.public.isMobile)

  const process = (e: MediaQueryListEvent) => {
    matches.value = e.matches
  }

  mediaQueryList.value?.addEventListener('change', process, { passive: true })

  const remove = () => mediaQueryList.value?.removeEventListener('change', process)

  onUnmounted(remove)

  return {
    mediaQueryList,
    matches,
    remove,
  }
}
